import { Set } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { TableUtils } from '../../jscaip/TableUtils';
import { ConnectSixFirstMove } from './ConnectSixMove';
import { ConnectSixDrops } from './ConnectSixMove';
import { ConnectSixState } from './ConnectSixState';
export class ConnectSixMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        if (node.gameState.turn === 0) {
            return this.getFirstMove(node.gameState);
        }
        else {
            return this.getListDrops(node);
        }
    }
    getFirstMove(state) {
        const width = state.getWidth();
        const height = state.getHeight();
        const cx = Math.floor(width / 2);
        const cy = Math.floor(height / 2);
        const center = new Coord(cx, cy);
        return [
            ConnectSixFirstMove.of(center),
        ];
    }
    getListDrops(node) {
        const availableFirstCoords = this.getAvailableCoords(node.gameState);
        const moves = [];
        for (const firstCoord of availableFirstCoords) {
            const board = node.gameState.getCopiedBoard();
            board[firstCoord.y][firstCoord.x] = node.gameState.getCurrentPlayer();
            const stateAfterFirstDrops = new ConnectSixState(board, node.gameState.turn);
            const availableSecondCoords = this.getAvailableCoords(stateAfterFirstDrops);
            for (const secondCoord of availableSecondCoords) {
                const newMove = ConnectSixDrops.of(firstCoord, secondCoord);
                moves.push(newMove);
            }
        }
        return new Set(moves).toList(); // Removes duplicates
    }
    getAvailableCoords(state) {
        const usefulCoord = this.getUsefulCoordsMap(state);
        const availableCoords = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            const coord = coordAndContent.coord;
            if (usefulCoord[coord.y][coord.x] && coordAndContent.content.isNone()) {
                availableCoords.push(coord);
            }
        }
        return availableCoords;
    }
    /**
     * This function returns a table on which table[y][x] is true only if:
     *     (x, y) is empty but has occupied neighbors
     */
    getUsefulCoordsMap(state) {
        const width = state.getWidth();
        const height = state.getHeight();
        const usefulCoord = TableUtils.create(width, height, false);
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            this.addNeighboringCoord(usefulCoord, coordAndContent.coord);
        }
        return usefulCoord;
    }
    /**
     * mark the space neighboring coord as "space that have an occupied neighbor"
     * @param usefulCoordTable a table of the board which each space mapped to true if it has an occupied neighbor
     * @param coord the coord to add to this map
     */
    addNeighboringCoord(usefulCoordTable, coord) {
        const usefulDistance = 1; // At two, it's already too much calculation for the minimax sadly
        const width = usefulCoordTable[0].length;
        const height = usefulCoordTable.length;
        const minX = Math.max(0, coord.x - usefulDistance);
        const minY = Math.max(0, coord.y - usefulDistance);
        const maxX = Math.min(width - 1, coord.x + usefulDistance);
        const maxY = Math.min(height - 1, coord.y + usefulDistance);
        for (let y = minY; y <= maxY; y++) {
            for (let x = minX; x <= maxX; x++) {
                usefulCoordTable[y][x] = true;
            }
        }
    }
}
